import { SxProps, Theme } from "@mui/material";

export const certificatesContainerStyles: SxProps<Theme> = {
  mt: 2,
};

export const certificatesListStyles: SxProps<Theme> = {
  display: "flex",
  gap: 2,
  overflow: "auto",
  flexDirection: "column",
  maxHeight: "400px",
};

export const certificateImageStyles: SxProps<Theme> = {
  borderRadius: "8px",
  cursor: "pointer",
};
